<template>
    <vProcessListComponent v-if="flag" :postList="postList"></vProcessListComponent>
</template>
<script>
import vProcessListComponent from '../../listComponent/processManage/processComponent.vue';
export default {
    name: 'processList',
    components: {
        vProcessListComponent
    },
    data() {
        return {
            flag: false,
            postList: {
                headerTitle: false,
                setBtn: true
            }
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style scoped>
</style>
